export default __webpack_public_path__ + "static/hearts-left-9626ceb1b82e81fa9278a81b1629b1d8.svg";